import { getCaptionValue } from '@pm2/content-engine';
import { defaultPm2PrintChunkClassName } from '@provider/print';
import { ScrambledCard } from './comp.scrambled.js';
import { jsx } from 'react/jsx-runtime';

const printIArkComponentPaper = node => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(ScrambledCard, {
      title: getCaptionValue(node.meta.caption.title) ?? ""
    })
  }];
};
const iArkComponentPaperPrinters = {
  "component-framework.i-ark": printIArkComponentPaper
};

export { iArkComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
